/**
 * Consumer (WandererTrip) web origin for connection-invite handoff.
 * Portcierge is not CORS-allowed for claim/accept against api.wanderertrip.com.
 */

export function getConsumerWebOrigin(): string {
  const fromEnv = String(import.meta.env.VITE_CONSUMER_WEB_ORIGIN || '')
    .trim()
    .replace(/\/$/, '');
  return fromEnv || 'https://wanderertrip.com';
}

/** Absolute WandererTrip URL to accept a connection invite in the browser. */
export function consumerInviteAcceptUrl(inviteId: string): string {
  const id = inviteId.trim();
  return `${getConsumerWebOrigin()}/invite/${encodeURIComponent(id)}/accept`;
}
